import { AbstractControl, ValidationErrors } from '@angular/forms';
  
export class CapsuleValidator {
    static cannotContainSpace(control: AbstractControl) : ValidationErrors | null {
        if(control.value >= 0){
            return {cannotContainSpace: true}
        }
        return null;
    }
}